// extracted by mini-css-extract-plugin
export default {"main":"passwordchange_main__9bpmW","primero":"passwordchange_primero__pjUYO","segundo":"passwordchange_segundo__zjMew"};